import dynamic from 'next/dynamic';
import { StayDetailsHeaderProps } from './StayDetailsHeader.types';

export const StayDetailsHeader = dynamic<StayDetailsHeaderProps>(() =>
  import('./StayDetailsHeader').then(module => module.StayDetailsHeader)
);
